import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMoon = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M27 23C21.5 23 17 18.5 17 13C17 12.1 17.1 11.2 17.4 10.4C13.1 11.5 10 15.4 10 20C10 25.5 14.5 30 20 30C24.6 30 28.5 26.9 29.6 22.6C28.8 22.9 27.9 23 27 23Z",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeMiterlimit: 10,
		strokeLinecap: "square"
	})
});
const ForwardRef = forwardRef(SvgMoon);
export default ForwardRef;
